import { useQuery } from '@tanstack/react-query'
import { zendeskQueries } from '@/features/zendesk-app'
import React from 'react'
import { Option } from '@/components/ui/Autocomplete/Autocomplete.types'

export const useZendeskFieldOptions = (types?: string[]): Option[] => {
  const query = useQuery({
    ...zendeskQueries.zendeskFields.list(),
    select: (data) => {
      if (!types) return data.ticket_fields
      return data.ticket_fields.filter((field) => types.includes(field.type))
    },
  })

  return React.useMemo(
    () =>
      query.data?.map((field) => ({
        label: field.title,
        value: field.id,
      })) ?? [],
    [query.data]
  )
}
